import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "rounded-lg border border-slate-200 bg-white"
};
const _hoisted_2 = {
  class: "flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 px-4 py-3"
};
const _hoisted_3 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_4 = {
  key: 0,
  class: "mt-0.5 text-xs text-slate-500"
};
const _hoisted_5 = {
  class: "flex items-center gap-2"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_8 = {
  class: "data-table-scroll"
};
const _hoisted_9 = {
  class: "data-table text-sm"
};
const _hoisted_10 = {
  class: "data-table-head"
};
const _hoisted_11 = {
  key: 0,
  class: "data-table-th text-center"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = ["colspan"];
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = ["colspan"];
const _hoisted_16 = {
  class: "data-table-td font-mono text-xs text-slate-900"
};
const _hoisted_17 = {
  class: "data-table-td is-right font-medium text-slate-900"
};
const _hoisted_18 = {
  class: "data-table-td is-right"
};
const _hoisted_19 = {
  class: "data-table-td"
};
const _hoisted_20 = {
  class: "data-table-td"
};
const _hoisted_21 = {
  class: "data-table-td"
};
const _hoisted_22 = {
  class: "data-table-td"
};
const _hoisted_23 = {
  class: "data-table-td"
};
const _hoisted_24 = {
  key: 0,
  class: "space-y-1"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  key: 1,
  class: "text-xs text-slate-400"
};
const _hoisted_28 = {
  key: 0,
  class: "data-table-td is-center"
};
import { computed, reactive, ref, watch } from 'vue';
import AppPagination from '@/components/AppPagination.vue';
import { getWealthContractBatchPage, getWealthFundBatchPage, getWealthMaturedUnhandledBatchPage, getWealthUpcomingMaturityBatchPage } from '@/api/wealth';
import WealthStatusBadge from './WealthStatusBadge.vue';
import { formatDate, formatMoney, formatRate, PAGE_SIZE_OPTIONS, pagePayload, syncPageResult } from '../utils';
export default {
  __name: 'WealthBatchPanel',
  props: {
    title: {
      type: String,
      default: '资金批次'
    },
    description: {
      type: String,
      default: ''
    },
    contractId: {
      type: Number,
      default: null
    },
    mode: {
      type: String,
      default: 'all'
    },
    showModeSwitch: {
      type: Boolean,
      default: true
    },
    extraQuery: {
      type: Object,
      default: () => ({})
    },
    ongoingOperations: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['view-operation', 'view-approval'],
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const rows = ref([]);
    const loading = ref(false);
    const modeValue = ref(props.mode);
    const pagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const query = computed(() => pagePayload(pagination, props.extraQuery));
    async function loadBatches() {
      loading.value = true;
      try {
        let result;
        if (props.contractId) {
          result = await getWealthContractBatchPage(props.contractId, query.value);
        } else if (modeValue.value === 'upcoming') {
          result = await getWealthUpcomingMaturityBatchPage(query.value);
        } else if (modeValue.value === 'matured') {
          result = await getWealthMaturedUnhandledBatchPage(query.value);
        } else {
          result = await getWealthFundBatchPage(query.value);
        }
        rows.value = result?.records || [];
        syncPageResult(pagination, result);
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    }
    function handlePageChange(page) {
      pagination.current = page;
      pagination.page = page;
      loadBatches();
    }
    function handleSizeChange(size) {
      pagination.size = size;
      pagination.current = 1;
      pagination.page = 1;
      loadBatches();
    }
    function formatOngoingOperation(operation = {}) {
      const amount = operation.amount ? ` ¥${formatMoney(operation.amount)}` : '';
      return `${operation.operationTypeLabel || operation.operationType || '操作'}${operation.statusLabel ? ` ${operation.statusLabel}` : ''}${amount}`;
    }
    function displayBatchStatus(row = {}) {
      if (row.status !== 'ACTIVE' || !row.maturityDate) {
        return row.status;
      }
      const maturityDate = new Date(`${String(row.maturityDate).slice(0, 10)}T00:00:00`);
      if (Number.isNaN(maturityDate.getTime())) {
        return row.status;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const upcomingDeadline = new Date(today);
      upcomingDeadline.setMonth(upcomingDeadline.getMonth() + 1);
      if (maturityDate > today && maturityDate <= upcomingDeadline) {
        return 'UPCOMING_MATURITY';
      }
      return row.status;
    }
    watch(() => props.mode, value => {
      modeValue.value = value;
    });
    watch([modeValue, () => props.contractId, () => props.extraQuery], () => {
      pagination.current = 1;
      pagination.page = 1;
      loadBatches();
    }, {
      immediate: true,
      deep: true
    });
    __expose({
      loadBatches
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("h4", _hoisted_3, _toDisplayString(__props.title), 1), __props.description ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [__props.showModeSwitch ? (_openBlock(), _createBlock(_component_el_select, {
        key: 0,
        modelValue: modeValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => modeValue.value = $event),
        class: "form-select form-control-sm w-40"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部批次",
          value: "all"
        }), _createVNode(_component_el_option, {
          label: "即将到期",
          value: "upcoming"
        }), _createVNode(_component_el_option, {
          label: "已到期未处理",
          value: "matured"
        })]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        disabled: loading.value,
        onClick: loadBatches
      }, "刷新", 8, _hoisted_6)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_createElementVNode("thead", _hoisted_10, [_createElementVNode("tr", null, [_cache[1] || (_cache[1] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "批次编号", -1)), _cache[2] || (_cache[2] = _createElementVNode("th", {
        class: "data-table-th text-right"
      }, "剩余本金", -1)), _cache[3] || (_cache[3] = _createElementVNode("th", {
        class: "data-table-th text-right"
      }, "年利率（%）", -1)), _cache[4] || (_cache[4] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "起息日", -1)), _cache[5] || (_cache[5] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "到期日", -1)), _cache[6] || (_cache[6] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "状态", -1)), _cache[7] || (_cache[7] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "提醒", -1)), _cache[8] || (_cache[8] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "进行中操作", -1)), _ctx.$slots.actions ? (_openBlock(), _createElementBlock("th", _hoisted_11, "操作")) : _createCommentVNode("", true)])]), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [_createElementVNode("td", {
        colspan: _ctx.$slots.actions ? 9 : 8,
        class: "data-table-empty"
      }, "加载中...", 8, _hoisted_13)])) : rows.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [_createElementVNode("td", {
        colspan: _ctx.$slots.actions ? 9 : 8,
        class: "data-table-empty"
      }, "暂无批次", 8, _hoisted_15)])) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 2
      }, _renderList(rows.value, row => {
        return _openBlock(), _createElementBlock("tr", {
          key: row.id,
          class: "data-table-row"
        }, [_createElementVNode("td", _hoisted_16, _toDisplayString(row.batchNo || '-'), 1), _createElementVNode("td", _hoisted_17, "¥" + _toDisplayString(_unref(formatMoney)(row.remainingPrincipalAmount)), 1), _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatRate)(row.annualRate)), 1), _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatDate)(row.valueDate)), 1), _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatDate)(row.maturityDate)), 1), _createElementVNode("td", _hoisted_21, [_createVNode(WealthStatusBadge, {
          type: "batch",
          value: displayBatchStatus(row),
          "show-dot": ""
        }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_22, [_createElementVNode("span", {
          class: _normalizeClass(['status-badge', row.reminderTaskId ? 'is-success ' : 'is-neutral '])
        }, _toDisplayString(row.reminderTaskId ? '已创建' : '未创建'), 3)]), _createElementVNode("td", _hoisted_23, [__props.ongoingOperations[row.id]?.length ? (_openBlock(), _createElementBlock("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ongoingOperations[row.id], operation => {
          return _openBlock(), _createElementBlock("div", {
            key: `${operation.applyId}-${operation.batchId}`,
            class: "inline-flex items-center gap-1"
          }, [_createElementVNode("button", {
            type: "button",
            class: "inline-flex items-center rounded-full status-badge is-warning px-2 py-0.5 text-xs font-medium hover:bg-amber-200",
            onClick: $event => _ctx.$emit('view-operation', operation)
          }, _toDisplayString(formatOngoingOperation(operation)), 9, _hoisted_25), operation.apply?.approvalInstanceId ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "table-action-button is-purple",
            title: "查看审批详情",
            "aria-label": "查看审批详情",
            onClick: _withModifiers($event => _ctx.$emit('view-approval', operation), ["stop"])
          }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })], -1)]))], 8, _hoisted_26)) : _createCommentVNode("", true)]);
        }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_27, "-"))]), _ctx.$slots.actions ? (_openBlock(), _createElementBlock("td", _hoisted_28, [_renderSlot(_ctx.$slots, "actions", {
          row: row
        })])) : _createCommentVNode("", true)]);
      }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
        key: 0,
        class: "pagination-bridge px-4 pb-4",
        pagination: pagination,
        "page-sizes": _unref(PAGE_SIZE_OPTIONS),
        onPageChange: handlePageChange,
        onSizeChange: handleSizeChange
      }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)]);
    };
  }
};